var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    accessibilityRole: "image"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6364 19C15.0909 19 14.7273 18.6 14.7273 18C14.7273 17.4 15.0909 17 15.6364 17C18.1818 17 20.1818 14.8 20.1818 12C20.1818 9.2 18.1818 7 15.6364 7C13.0909 7 11.0909 9.2 11.0909 12C11.0909 12.6 10.7273 13 10.1818 13C9.63636 13 9.27273 12.6 9.27273 12C9.27273 8.1 12.0909 5 15.6364 5C19.1818 5 22 8.1 22 12C22 15.9 19.1818 19 15.6364 19ZM8.18182 18.8C4.72727 18.8 2 15.7 2 12C2 8.3 4.72727 5.2 8.18182 5.2C8.72727 5.2 9.09091 5.6 9.09091 6.2C9.09091 6.8 8.72727 7.2 8.18182 7.2C5.72727 7.2 3.81818 9.4 3.81818 12C3.81818 14.6 5.72727 16.8 8.18182 16.8C10.6364 16.8 12.5455 14.7 12.5455 12C12.5455 11.4 12.9091 11 13.4545 11C14 11 14.3636 11.4 14.3636 12C14.2727 15.7 11.5455 18.8 8.18182 18.8Z",
    fill: "#037DD6"
  })));
};
export default SvgLink;